import dayjs from "dayjs";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import {
  FormController,
  MuiBox,
  MuiDateFieldFormController,
  MuiGrid,
  MuiSelect,
  MuiTextField,
  OptionsDataType,
} from "../../../../../../../../../../components";
import { MAX_LENGTH_500 } from "../../../../../../../../../../helpers/constants";
import { useNavigationSiteCore } from "../../../../../../../../../../hooks/useNavigationSiteCore";
import { useSiteCore } from "../../../../../../../../../../hooks/useSiteCore";
import { ProjectStatusFormKey } from "../../../../../../../../modelsAndSchemas/Models";
import { projectStatusChangeSiteCoreKeys } from "../../../../../../../../siteCore/SiteCoreKeys";

interface ChangStatusFieldsProps {
  pageId: string;
  userCountryDateFormat?: string;
  projectStatusList: OptionsDataType[];
}

export const ChangStatusFields: FC<ChangStatusFieldsProps> = ({
  pageId,
  userCountryDateFormat = "",
  projectStatusList,
}) => {
  const { control, getValues } = useFormContext();
  const gridSize = { md: 6, sm: 6, xs: 12 };

  const { commonLabels, fetchLabel } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();

  const getLabel = (key: string) => {
    return fetchLabel(projectStatusChangeSiteCoreKeys.header, key);
  };

  return (
    <MuiBox className="change-status-form" data-testid="change-status-form">
      <MuiGrid container className="form-container">
        <MuiGrid size={gridSize} className="form-field">
          <FormController control={control} name={ProjectStatusFormKey.status}>
            <MuiSelect
              label={getLabel(projectStatusChangeSiteCoreKeys.statusLabel)}
              options={projectStatusList}
              id={`${pageId}-${ProjectStatusFormKey.status}`}
              placeholder={commonLabels.selectPlaceHolder}
              searchPlaceholder={commonLabels.search}
              requiredARIALabel={commonARIALabel.required}
            />
          </FormController>
        </MuiGrid>
        <MuiGrid size={gridSize} className="status-field">
          <MuiDateFieldFormController
            control={control}
            name={ProjectStatusFormKey.date}
            className="date-picker"
            label={getLabel(projectStatusChangeSiteCoreKeys.dateLabel)}
            id={`${pageId}-${ProjectStatusFormKey.date}`}
            disableManualInput
            format={userCountryDateFormat}
            disablePast
            value={
              getValues(ProjectStatusFormKey.date) !== ""
                ? dayjs(
                    getValues(ProjectStatusFormKey.date),
                    userCountryDateFormat,
                  )
                : null
            }
            requiredARIALabel={commonARIALabel.required}
            selectDateARIALabel={commonARIALabel.selectDate}
          />
        </MuiGrid>
        <MuiGrid size={{ xs: 12 }} className="status-field">
          <FormController control={control} name={ProjectStatusFormKey.notes}>
            <MuiTextField
              id={`${pageId}-${ProjectStatusFormKey.notes}`}
              label={commonLabels.comment}
              placeholder={commonLabels.inputPlaceHolder}
              isTextarea
              multiline
              rows={4}
              maxLength={MAX_LENGTH_500}
              requiredARIALabel={commonARIALabel.required}
            />
          </FormController>
        </MuiGrid>
      </MuiGrid>
    </MuiBox>
  );
};
